// layout/AdminLayout.tsx
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminSidebar from "../admin/AdminSidebar";
import Footer from "../components/Footer";
import { LocalStorageManager } from "../lib/localStorage-manager";
import { tokenManager } from "../lib/token-manager";

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");
  const username = LocalStorageManager.getUserName() || "Admin User";

  const signOut = () => {
    tokenManager.removeToken();
    LocalStorageManager.removeOrgPrimaryId();
    LocalStorageManager.removeUserName();
    LocalStorageManager.removeOrgdata();
    navigate("/");
  };

  return (
    <div className="app-shell">
      <AdminSidebar />

      <main className="app-main admin-main">
        <div className="app-heading">
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src={tsmclogo} alt="TSMC Logo" className="app-heading-logo" />
            <span className="app-heading-title">
              Admin Console - Telangana Medical Council
            </span>
          </div>

          <div className="profile-chip global-chip">
            <span className="email-text">
              <i className="bi bi-shield-lock-fill"></i>
              {username}
            </span>
            <button type="button" className="ghost" onClick={signOut}>
              Logout
            </button>
          </div>
        </div>

        <div className="admin-content">
          <Outlet />
        </div>

        <Footer />
      </main>
    </div>
  );
};

export default AdminLayout;
